RivalIQ.apps.Insights.module('curations', function (curations, App, Backbone, Marionette, $, _) {

    'use strict';

    const Dashboard = RivalIQ.apps.Dashboard;
    const widgetTypes = RivalIQ.enums.widgetTypes;

    const widgets = [
        {
            instanceId: 'additional-auth-facebook',
            widgetId: RivalIQ.enums.widgetTypes.ADDITIONAL_AUTHORIZATION,
            region: 'top',
            supportedExportFormats: [],
            props: {
                source: RivalIQ.enums.sources.FACEBOOK_INSIGHTS
            }
        },
        {
            instanceId: 'fb-ads-token-request',
            widgetId: RivalIQ.enums.widgetTypes.FB_ADS_TOKEN_REQUEST,
            region: 'top',
            supportedExportFormats: [],
            props: {
                source: RivalIQ.enums.sources.FACEBOOK_INSIGHTS
            }
        },
        {
            instanceId: 'section-page-fans',
            widgetId: widgetTypes.FB_INSIGHTS_PAGE_FANS,
            region: 'top-left',
            className: 'x-normalize-heights'
        },
        {
            instanceId: 'section-impressions-reach',
            widgetId: widgetTypes.FB_INSIGHTS_IMPRESSIONS_REACH,
            region: 'top-right',
            className: 'x-normalize-heights'
        },
        {
            instanceId: 'page-consumptions',
            widgetId: RivalIQ.enums.widgetTypes.FB_INSIGHTS_PAGE_CONSUMPTIONS,
            region: 'middle-left'
        },
        {
            instanceId: 'page-views',
            widgetId: RivalIQ.enums.widgetTypes.FB_INSIGHTS_PAGE_VIEWS,
            region: 'middle-right'
        },
        {
            instanceId: 'page-reach-gender',
            widgetId: RivalIQ.enums.widgetTypes.FB_INSIGHTS_PAGE_REACH_GENDER,
            region: 'middle-bottom-left'
        },
        {
            instanceId: 'page-reach-age',
            widgetId: RivalIQ.enums.widgetTypes.FB_INSIGHTS_PAGE_REACH_AGE,
            region: 'middle-bottom-right'
        },
        {
            instanceId: 'page-fans-locations',
            widgetId: widgetTypes.FB_INSIGHTS_PAGE_FANS_LOCATIONS,
            region: 'bottom-left'
        },
        {
            instanceId: 'page-impressions-and-reach-locations',
            widgetId: widgetTypes.FB_INSIGHTS_PAGE_IMPRESSIONS_AND_REACH_LOCATIONS,
            region: 'bottom-right'
        }
    ];

    const config = [
        [
            {
                name: 'top-left',
                className: 'x-normalize-heights',
                sizes: {
                    md: 6,
                    sm: 12,
                    'sm-export': 6
                },
                page: 0
            },
            {
                name: 'top-right',
                className: 'x-normalize-heights',
                sizes: {
                    md: 6,
                    sm: 12,
                    'sm-export': 6
                },
                page: 0
            }
        ],
        [
            {
                name: 'middle-left',
                className: 'x-normalize-heights',
                sizes: {
                    md: 6,
                    sm: 12,
                    'sm-export': 6
                },
                page: 0
            },
            {
                name: 'middle-right',
                className: 'x-normalize-heights',
                sizes: {
                    md: 6,
                    sm: 12,
                    'sm-export': 6
                },
                page: 0
            }
        ],
        [
            {
                name: 'middle-bottom-left',
                className: 'x-normalize-heights',
                sizes: {
                    md: 6,
                    sm: 12,
                    'sm-export': 6
                },
                page: 1
            },
            {
                name: 'middle-bottom-right',
                className: 'x-normalize-heights',
                sizes: {
                    md: 6,
                    sm: 12,
                    'sm-export': 6
                },
                page: 1
            }
        ],
        [
            {
                name: 'bottom-left',
                className: 'x-normalize-heights',
                sizes: {
                    md: 6,
                    sm: 12,
                    'sm-export': 6
                },
                page: 1
            },
            {
                name: 'bottom-right',
                className: 'x-normalize-heights',
                sizes: {
                    md: 6,
                    sm: 12,
                    'sm-export': 6
                },
                page: 1
            }
        ]
    ];

    const FacebookInsightsLayout = Dashboard.views.CurationLayout.extend({
        config: config,

        showLeftToolbarActions: function () {
            const me = this;

            const toolbar = me.getToolbarDefinition();
            const view = RivalIQ.apps.Shell.views.Toolbar.createFromConfig(toolbar);
            me.leftActions.show(view);
        },

        getToolbarDefinition: function () {
            const me = this;
            const toolbar = {
                items: []
            };

            if (me.dashboardModel.canLoadAds()) {
                toolbar.items.push({
                    config: {
                        view: App.views.AdsLoadingView,
                        model: new App.models.FacebookAdsSyncStatus(me.getProp('presenceId')),
                        dashboardModel: me.dashboardModel
                    }
                });
            }

            return toolbar;
        }
    });

    const ExportLayout = Dashboard.views.ExportWidgets.extend({
        childView: Dashboard.views.ExportLayout.extend({
            config: config
        })
    });

    const channelWall = Dashboard.curations.filters.ChannelFilterFactory({
        template: '#widgetFacebookInsightsAuthTemplate',
        upsellTemplate: '#widgetFacebookInsightsUpsellTemplate',
        channel: RivalIQ.enums.sources.FACEBOOK_INSIGHTS
    });

    curations.FacebookInsightsCuration = curations._BaseFacebookInsightsCuration.extend({
        beforeFilters: [
            curations.filters.fbPresenceLoader,
            channelWall,
            curations.filters.noFacebookInsightsPresences,
            curations.filters.checkAccountAccess(RivalIQ.enums.sources.FACEBOOK_INSIGHTS),
            curations.filters.insightsLoading(RivalIQ.enums.sources.FACEBOOK_INSIGHTS, '/insights/facebook'),
            RivalIQ.apps.Dashboard.curations.filters.updateShell
        ],

        widgetsView: function () {
            return FacebookInsightsLayout;
        },
        exportWidgetsView: function () {
            return ExportLayout;
        },

        buildConfiguration: function () {
            const definitions = widgets;
            return new RivalIQ.apps.Dashboard.models.Configuration({
                props: {
                    source: RivalIQ.enums.sources.FACEBOOK_INSIGHTS,
                    channel: RivalIQ.enums.channels.FACEBOOK
                },
                definitions: definitions
            });
        }
    });
});
